import { HubCard } from "~/components/hub-card";
import { Sunburst } from "~/components/sunburst/sunburst";
import { useAssetUrlStats } from "~/hooks/useAssetUrlStats";
import { AssetUrlStatsScope } from "~/operations";
import { SpaceOrWorkspaceScope, SpaceScope } from "~/hooks/useScope";
import { FleetIcon } from "~/icons";

interface HomeDashboardInventoryOverviewCardSunburstProps {
  scope: SpaceOrWorkspaceScope | undefined;
  spaceScope: SpaceScope | undefined;
}

export function HomeDashboardInventoryOverviewCardSunburst({
  scope,
  spaceScope,
}: HomeDashboardInventoryOverviewCardSunburstProps) {
  const assetUrlStats = useAssetUrlStats({
    scope,
    spaceScope,
    statsScope: AssetUrlStatsScope.All,
  });

  return (
    <HubCard
      {...{
        loading: assetUrlStats.queryResult.loading,
        title: "Inventory Overview",
        icon: <FleetIcon />,
        sx: { height: "100%" },
      }}
    >
      <Sunburst assetUrlStats={assetUrlStats} />
    </HubCard>
  );
}
